import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  FormLabel,
  Alert,
  Box,
  Grid,
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { normalizeText } from "./helpers/Helpers";
import { modificarNotas } from "./helpers/ContactPlusClient/ContactNClientsHelpers";
import Swal from "sweetalert2";

const getTextfieldStyle = (errorNotes) => {
  let borderColor = " 1px solid rgba(128, 128, 128, 0.35)";
  if (errorNotes === 1) borderColor = " 2px solid #13cc3bff"; // advertencia
  else if (errorNotes === 2) borderColor = " 2px solid #EF5350"; // error
  return {
    resize: "none",
    padding: "6px 13px",
    fontSize: "14px",
    border: ` ${borderColor}`,
    borderRadius: "4px",
    outline: "none",
  };
};

export default function ContactClientNotesComparisonDialog({
  notas,
  client,
  contact,
  setFlagToReload,
  flagToReload,
}) {
  const [open, setOpen] = useState(false);
  const [clienteNote, setClienteNote] = useState("");
  const [contactoNote, setContactoNote] = useState("");
  const [errorNotes, setErrorNotes] = useState(0);
  const [canUnify, setCanUnify] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const timeoutRef = useRef(null);

  const handleOpen = () => {
    setClienteNote(notas?.[0]?.cliente || "");
    setContactoNote(notas?.[1]?.contacto || "");
    setErrorNotes(0);
    setCanUnify(false);
    setShowAlert(false);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleConfirmUnification = async () => {
    console.log(contact);

    if (canUnify) {
      Swal.fire({
        title: "Unificando notas...",
        text: "Por favor espere mientras se sincronizan los registros.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await Promise.all([
          modificarNotas(contact?.id, contactoNote, "contacto"),
          modificarNotas(client?.id, clienteNote, "cliente"),
        ]);
        // modificarNotasCliente(client?.id, clienteNote);
        console.log(" Notas unificadas exitosamente");

        Swal.fire({
          icon: "success",
          title: "Notas unificadas correctamente",
          showConfirmButton: false,
          timer: 1500,
        });

        setFlagToReload(!flagToReload);
        handleClose();
      } catch (error) {
        console.error("   Error al unificar notas:", error);
        Swal.fire({
          icon: "error",
          title: "Error al unificar notas",
          text: "Por favor, inténtelo nuevamente.",
        });
      }
    } else {
      setShowAlert(true);
    }
  };

  // Compara notas con un retraso de 2s después de cada cambio
  useEffect(() => {
    if (!open) return;

    // Limpia temporizador anterior para evitar comparaciones innecesarias
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      console.debug("🕒 Comparando notas...");
      console.debug("Cliente:", clienteNote);
      console.debug("Contacto:", contactoNote);

      const areEqual =
        normalizeText(clienteNote) === normalizeText(contactoNote);

      if (areEqual) {
        console.debug(" Notas iguales");
        setCanUnify(true);
        setErrorNotes(1);
        setShowAlert(false);
      } else {
        console.debug("⚠️ Notas diferentes");
        setCanUnify(false);
        setErrorNotes(2);
        setShowAlert(true);
      }
    }, 1000);

    return () => clearTimeout(timeoutRef.current);
  }, [clienteNote, contactoNote, open]);

  return (
    <>
      <Button
        variant="outlined"
        color="warning"
        onClick={handleOpen}
        sx={{ marginLeft: "20px" }}>
        CLIC PARA UNIFICAR NOTAS
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lf"
        fullWidth
        aria-labelledby="dialog-title">
        <DialogTitle
          id="dialog-title"
          sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Warning color="warning" />
          UNIFICACIÓN DE NOTAS CLIENTE/CONTACTO
        </DialogTitle>

        <DialogContent dividers>
          <Typography sx={{ mb: 2 }}>
            Por favor, verifique que las notas sean exactamente iguales:
          </Typography>

          <Grid container>
            <Grid item xs={6} p={1}>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <FormLabel sx={{ mb: "10px" }}>
                  Nota principal del cliente
                </FormLabel>
                <textarea
                  style={getTextfieldStyle(errorNotes)}
                  rows={15}
                  value={clienteNote}
                  onChange={(e) => setClienteNote(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} p={1}>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: "10px" }}>
                  Nota principal del contacto
                </FormLabel>
                <textarea
                  style={getTextfieldStyle(errorNotes)}
                  rows={15}
                  value={contactoNote}
                  onChange={(e) => setContactoNote(e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>

          {showAlert && (
            <Box sx={{ mt: 2 }}>
              <Alert severity="warning">
                Las notas no son iguales. Por favor, verifique el contenido.
              </Alert>
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="error" variant="outlined">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmUnification}
            disabled={!canUnify ? true : false}
            color={canUnify ? "success" : "primary"}
            variant="contained">
            {canUnify ? "Guardar" : "No dispoible"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
